import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../components/usercontext/user_context";
import ResumeUpload from "./ResumeUpload";

const Workersidebar = () => {
  const { t } = useTranslation();
  const { user, updateUser } = useContext(UserContext);
  const [cvId, setCvId] = useState(null); // онлайн CV
  const [uploadedCV, setUploadedCV] = useState(null); // путь к загруженному файлу
  const [selectedFileName, setSelectedFileName] = useState(""); // имя файла для отображения

  // --- Получаем данные при монтировании ---
  useEffect(() => {
    if (!user?.id) return;

    // --- Онлайн CV ---
    fetch(`/api/get_cv.php?user_id=${user.id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.cv) {
          setCvId(data.cv.id || null);
          // 🔹 Сохраняем в localStorage
          localStorage.setItem(`cvId_${user.id}`, data.cv.id);
        } else {
          setCvId(null);
          localStorage.removeItem(`cvId_${user.id}`);
        }
      })
      .catch((err) => {
        console.error("Ошибка получения онлайн CV:", err);
        setCvId(null);
      });

    // --- Последний загруженный файл ---
    fetch(`/api/get_uploaded_cv.php?user_id=${user.id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.file_path) {
          setUploadedCV(data.file_path);
          const fileName = data.file_path.includes("/") 
            ? data.file_path.split("/").pop() 
            : data.file_path;
          setSelectedFileName(fileName);
          // 🔹 Сохраняем в localStorage
          localStorage.setItem(`uploadedCV_${user.id}`, JSON.stringify({
            file_path: data.file_path,
            file_name: fileName
          }));
        } else {
          setUploadedCV(null);
          setSelectedFileName("");
          localStorage.removeItem(`uploadedCV_${user.id}`);
        }
      })
      .catch((err) => {
        console.error("Ошибка получения загруженного файла:", err);
        setUploadedCV(null);
        setSelectedFileName("");
      });
  }, [user?.id]);

  // 🔹 При загрузке страницы восстанавливаем данные из localStorage
  useEffect(() => {
    if (!user?.id) return;
    
    // Восстанавливаем cvId
    const savedCvId = localStorage.getItem(`cvId_${user.id}`);
    if (savedCvId && !cvId) {
      setCvId(savedCvId);
    }
    
    // Восстанавливаем uploadedCV
    const savedUploadedCV = localStorage.getItem(`uploadedCV_${user.id}`);
    if (savedUploadedCV && !uploadedCV) {
      try {
        const parsed = JSON.parse(savedUploadedCV);
        setUploadedCV(parsed.file_path);
        setSelectedFileName(parsed.file_name);
      } catch (e) {
        console.error("Ошибка парсинга uploadedCV из localStorage:", e);
      }
    }
  }, [user?.id]);

  return (
    <aside className="w-full z-20">
      <ul className="space-y-3 w-full">
        <li>
          <Link
            to="/myPersonalPage"
            className="py-2 px-4 flex capitalise text-lg max-sm:text-[16px] rounded-md bg-white text-[#006674] transition-all duration-200 hover:bg-gray-200 hover:shadow-2xl hover:shadow-black w-full"
          >
            {t("personalinformation")}
          </Link>
        </li>

        <li>
          <Link
            to={user ? `/MyLikedVacancies/${user.id}` : "/WorkerChoose"}
            className="py-2 px-4 flex capitalise text-lg max-sm:text-[16px] rounded-md bg-white text-[#006674] transition-all duration-200 hover:bg-gray-200 hover:shadow-2xl hover:shadow-black w-full"
          >
            {t("savevacancies")}
          </Link>
        </li>

        <li>
          <Link to='/Responses' className="py-2 px-4 flex text-lg capitalise max-sm:text-[16px] rounded-md bg-white text-[#006674] transition-all duration-200 hover:gray-200 hover:shadow-2xl hover:shadow-black w-full">
            {t("Listofsubmitted")}
          </Link>
        </li>
        <li>
          <Link to='/Notifications' className="py-2 px-4 flex text-lg capitalise max-sm:text-[16px] rounded-md bg-white text-[#006674] transition-all duration-200 hover:gray-200 hover:shadow-2xl hover:shadow-black w-full">
            {t("Notifications")}
          </Link>
        </li>

        {/* --- Онлайн CV или загруженный файл --- */}
        <li className="w-full">
          {cvId ? (
            <Link
              to={`/cv/${cvId}`}
              className="capitalise flex w-full text-lg max-sm:text-[20px] hover:shadow-2xl hover:shadow-black px-3 py-2 bg-white text-[#006674] rounded-md transition-all duration-200 hover:bg-gray-200"
            >
              իմ օնլայն CV
            </Link>
          )  : (
            <Link
              to="/create_cv"
              className="capitalise flex w-full text-lg max-sm:text-[20px] hover:shadow-2xl hover:shadow-black px-3 py-2 bg-white text-[#006674] rounded-md transition-all duration-200 hover:bg-gray-200"
            >
              {t("CreateCV")}
            </Link>
          )}
        </li>

        {/* --- Загрузка нового файла с отображением имени справа --- */}
        <li className="flex items-center gap-2">
          {user?.id && <ResumeUpload userId={user.id} updateUser={updateUser} />}
        </li>
      </ul>
    </aside>
  );
};

export default Workersidebar;